import { useEffect } from "react";
import SiteNav from "@/components/marketing/SiteNav";
import SiteFooter from "@/components/marketing/SiteFooter";
import { Hero, About, Services, WhyUs, Network, Contact } from "@/components/marketing/Sections";
import { Partners, Latam, NamedPatient } from "@/components/marketing/LatamSections";
import { Mena } from "@/components/marketing/MenaSection";
import { Africa } from "@/components/marketing/AfricaSection";
import { WhatsAppIcon, WA_LINK } from "@/components/marketing/WhatsAppIcon";

export default function HeliopolisWebsite() {
  useEffect(() => {
    const prev = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = "smooth";
    return () => { document.documentElement.style.scrollBehavior = prev; };
  }, []);

  return (
    <div className="min-h-screen bg-white font-[Inter,ui-sans-serif,system-ui] text-[#0D1B2A] antialiased" data-testid="heliopolis-website">
      <SiteNav />
      <main>
        <Hero />
        <Partners />
        <About />
        <NamedPatient />
        <Latam />
        <Mena />
        <Africa />
        <Services />
        <WhyUs />
        <Network />
        <Contact />
      </main>
      <SiteFooter />
      <a
        href={WA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
        data-testid="whatsapp-float-button"
        className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_14px_34px_-10px_rgba(37,211,102,0.8)] transition-transform hover:scale-105"
      >
        <WhatsAppIcon size={28} />
      </a>
    </div>
  );
}
